import {cleanEntity} from "@mytour/platform";
import {AppointmentAvailabilitySchema, ServiceDescriptionPageMetaSchema} from "@mytour/shared";
import type {
  IServiceDescription,
  ServiceDescriptionPage,
  ServiceDescriptionReadResponse,
  ServiceDescriptionWriteResponse,
} from "@mytour/shared";
import axios from "axios";

const apiUrl = "api/service-descriptions";

/**
 * Les taux TVA restent élargis dans les entités ; les schémas de création et
 * modification les valident à la frontière serveur.
 */
export const serviceDescriptionApiService = {
  async getServiceDescriptionPage(): Promise<ServiceDescriptionPage> {
    const result = await axios.get<ServiceDescriptionReadResponse[]>(
      "api/service-descriptions/current/"
    );
    const meta = ServiceDescriptionPageMetaSchema.parse({
      appointments: result.headers["x-appointment-availability"]
        ? {
            kind: result.headers["x-appointment-availability"],
            eventId: result.headers["x-appointment-id"],
          }
        : undefined,
    });
    if (result.data.length === 0) {
      AppointmentAvailabilitySchema.parse(meta.appointments);
    }
    return {data: result.data, meta};
  },
  async getCurrentUserServiceDescriptions(): Promise<ServiceDescriptionReadResponse[]> {
    const result = await axios.get<ServiceDescriptionReadResponse[]>(`${apiUrl}/current/`);
    return result.data;
  },

  async getServiceDescription(id: string): Promise<ServiceDescriptionReadResponse | undefined> {
    const result = await axios.get<ServiceDescriptionReadResponse | undefined>(`${apiUrl}/${id}`);
    return result.data;
  },

  async createServiceDescription(entity: IServiceDescription): Promise<IServiceDescription> {
    const result = await axios.post<ServiceDescriptionWriteResponse>(apiUrl, cleanEntity(entity));
    return {...result.data, account: result.data.account ?? null};
  },

  async updateServiceDescription(
    entity: IServiceDescription
  ): Promise<ServiceDescriptionWriteResponse> {
    const result = await axios.put<ServiceDescriptionWriteResponse>(apiUrl, cleanEntity(entity));
    return result.data;
  },

  async deleteServiceDescription(id: string): Promise<void> {
    await axios.delete(`${apiUrl}/${id}`);
  },
};
